import { useDateFormat } from '@gogame/intl-ts';

import {
  DAY,
  WEEK,
  HOURS,
  ONCE,
} from 'scenes/SmartRules/SmartRuleForm/Schedule';

export const numberWithZero = (i) => {
  return `${i.toString().padStart(2, '0')}`;
};

export const useSchedule = ({ data }) => {
  const dateFormatLL = useDateFormat({ timeZone: 'local', template: 'LL' });
  const dateFormatLT = useDateFormat({ timeZone: 'local', template: 'LT' });
  const date = new Date();
  const dateForTime = new Date(
    Date.UTC(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate(),
      data.schedule.runAtHours,
      data.schedule.runAtMinutes
    )
  );
  const runAtHoursLocal = dateForTime.getHours();
  const runAtMinutesLocal = dateForTime.getMinutes();
  const runAtHours = numberWithZero(runAtHoursLocal);
  const runAtMinutes = numberWithZero(runAtMinutesLocal);

  return {
    [DAY]: `Every day at ${runAtHours}:${runAtMinutes}`,
    [WEEK]: `${data.schedule.repeatDays?.join(
      ', '
    )} at ${runAtHours}:${runAtMinutes}`,
    [HOURS]: `Every ${data.schedule.intervalHours} hours`,
    [ONCE]: `Once ${dateFormatLL(data.schedule.runOnceDate)} at ${dateFormatLT(
      data.schedule.runOnceDate
    )}`,
  }[data.schedule.recurrence];
};
